/**
 * Domain color palette for Riftbound.
 * Used by DomainBadge and any other UI that needs per-domain coloring.
 */
export const DOMAIN_COLORS = {
  Fury:  '#e05252', // warm red
  Calm:  '#52a8e0', // soft blue
  Mind:  '#a852e0', // purple
  Body:  '#52c452', // green
  Chaos: '#e09c52', // amber/orange
  Order: '#f5f0d0', // pale gold / off-white
};

/**
 * Return the hex color for a domain name (case-insensitive).
 * Falls back to a neutral gray if the domain is unknown.
 *
 * @param {string} name - Domain name e.g. "Fury"
 * @returns {string} hex color string
 */
export function domainColor(name) {
  if (!name) return '#888888';
  // Capitalise first letter so "fury" and "Fury" both match
  const normalised = name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  return DOMAIN_COLORS[normalised] ?? '#888888';
}
